// extracted by mini-css-extract-plugin
export default {"root":"styles-scoped__root--w7nyE","modal":"styles-scoped__modal--RiCH1"};